import React, { useMemo } from 'react';
import cn from 'classnames';
import Tag from 'components/UI/Tag';
import { useTrans } from 'utils/localisation';
import { POPULAR_SEARCHES } from 'define/search';
import { getHeaderDeviceType } from 'utils';
import { useHorizontalScroll } from 'utils/hooks';
import { pushSearchEvent } from 'utils/analytics';
import { observer, searchStore as store } from 'store';

import * as styles from './PopularSearches.module.scss';

function PopularSearches({ className, handleTagClick, theme }) {
  const t = useTrans(['common']);
  const { scrollRef } = useHorizontalScroll();

  const preparedStyle = useMemo(() => {
    const style = {
      '--left': store.mobileSearchCoordinates.left,
      '--right': store.mobileSearchCoordinates.right,
    };

    return style;
  }, [store.mobileSearchCoordinates]);

  const handleClick = value => {
    const deviceType = getHeaderDeviceType(window.innerWidth);
    handleTagClick(value);
    pushSearchEvent({
      action: 'click_on_popular',
      label: value,
      deviceType,
      pageUrl: window.location.href,
    });
  };

  return (
    <div
      className={cn(styles.wrapper, theme && styles[theme], className)}
      style={theme === 'mobile' ? preparedStyle : {}}
    >
      <div className={styles.title}>{t('popularSearches')}</div>
      <div className={styles.tagsRow} ref={scrollRef}>
        {POPULAR_SEARCHES?.map(tag => (
          <Tag className={styles.tag} key={tag} rounded onClick={() => handleClick(tag)}>
            {tag}
          </Tag>
        ))}
      </div>
    </div>
  );
}

export default observer(PopularSearches);
